export default "__VITE_ASSET__THtVE_UU__"